import dayjs, { Dayjs } from 'dayjs'

export const getStartOfDay = (
  dateTime: Dayjs | number | string = dayjs()
): Dayjs => {
  const date = dayjs(dateTime)
  const startOfDay = dayjs(date.toDate().setHours(0, 0, 0, 0))
  return startOfDay
}
